module.exports = __webpack_public_path__ + "static/media/saturn2.7c76f7e3.png";